import "./App.css";

import { DragDropContextProvider } from "@vimana/ui-components/dist/Components/Core/DragDrop";
import React from "react";
import { createHashRouter, RouterProvider } from "react-router-dom";

import { PlantWrapper } from "./PlantWrapper";
import { ProtectedRoutes } from "./Routes/ProtectedRoutes";
import { UnProtectedRoutes } from "./Routes/UnProtectedRoutes";
import { ThemeWrapper } from "./ThemeWrapper";
import { LocaleProvider } from "./Translator/LocaleProvider";
import { ErrorHandler } from "./Utils/errorHandler";

// A data router rather than <HashRouter>: React Router's blocker API, which the
// unsaved-changes Prompt relies on, only exists under one. The existing tree hangs
// off a single catch-all route, so the sibling <Routes> groups inside it keep
// matching absolute paths from "/" exactly as before.
const router = createHashRouter(
  [
    {
      path: "*",
      element: (
        <>
          <ProtectedRoutes />
          <UnProtectedRoutes />
        </>
      ),
    },
  ],
  {
    // Relative-path resolution under splat routes changes in v7. Every path in this
    // app is absolute, so opting in early is safe and silences the dev-time notice.
    future: { v7_relativeSplatPath: true },
  }
);

/**
 * Service worker assumes ThemeWrapper for a plant loads before any other components.
 * This is to access plant information from branding:
 * - See src.ts
 */
export const App = () => {
  return (
    <ErrorHandler>
      <PlantWrapper>
        {/*
          One drag-and-drop manager for the whole app. react-dnd keeps its manager in a
          window-global slot that the last unmounting DndProvider clears; when a screen
          hands off to another in one commit the new provider has already adopted the old
          manager, the slot is cleared under it, and the next provider to mount (the device
          filter's tree, the editor) creates a second HTML5 backend and throws. A provider
          that never unmounts keeps the slot populated so every nested provider — the
          per-screen editors and react-sortable-tree's own — shares this one manager.
        */}
        <DragDropContextProvider>
          <ThemeWrapper>
            <LocaleProvider>
              <RouterProvider router={router} />
            </LocaleProvider>
          </ThemeWrapper>
        </DragDropContextProvider>
      </PlantWrapper>
    </ErrorHandler>
  );
};
